import { render } from "./BotLogList.vue?vue&type=template&id=6112fc5b&scoped=true"
import script from "./BotLogList.vue?vue&type=script&lang=js"
export * from "./BotLogList.vue?vue&type=script&lang=js"

import "./BotLogList.vue?vue&type=style&index=0&id=6112fc5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6112fc5b"]])

export default __exports__